'use client';
import _extends from '@babel/runtime/helpers/extends';
import React__default, { useContext, Suspense, Fragment } from 'react';
import { CohesionContext } from './Provider.js';

const Preamp = _ref => {
  let {
    placement,
    children = null,
    skeleton: Skeleton = () => /*#__PURE__*/React__default.createElement(React__default.Fragment, null),
    bypassSkeleton,
    ...rest
  } = _ref;
  const {
    assets,
    renderedDecisions
  } = useContext(CohesionContext);

  // We do not have a Preamp decision yet. If a skeleton compnent has been passed in use it.
  // If not we are in a deprecated min-height state so return a Fragment.
  if (!renderedDecisions && !bypassSkeleton) return /*#__PURE__*/React__default.createElement(Skeleton, null);

  // Get asset data.
  const {
    assetName,
    name,
    metadata = {}
  } = renderedDecisions?.[placement] || {};

  // Monarch returned asset has "name", Preamp returned asset has "assetName"
  const assetTitle = assetName ?? name ?? '';
  const filteredName = assetTitle.includes('@') ? assetTitle.split('@')[0].trimEnd() : assetTitle;
  const InjectedPreampAsset = assets?.[filteredName];

  // If a test needs to override the child component place it an inject the component.
  if (InjectedPreampAsset) {
    return /*#__PURE__*/React__default.createElement(Suspense, {
      fallback: /*#__PURE__*/React__default.createElement(Skeleton, null)
    }, /*#__PURE__*/React__default.createElement(InjectedPreampAsset, _extends({}, rest, {
      metadata: metadata
    })));
  }

  // Check if the child is a function if so we will need to call it and pass in the metadata.
  const isRenderProps = typeof children === 'function';

  // If we dont have an injected component we want to return the child component.
  // If it is a renderProp call it and pass in the metadata.
  // Else map over the children and inject the metadata as props into the component.
  return isRenderProps ? children(metadata) : /*#__PURE__*/React__default.createElement(Fragment, null, React__default.Children.map(children, child => {
    if ( /*#__PURE__*/React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.cloneElement(child, metadata);
    }
    return child;
  }));
};
Preamp.displayName = 'Preamp';

export { Preamp };
